export default import.meta.ROLLDOWN_FILE_URL_0I0gGYT54E8zRKvPRpaQZQ